import { schema } from "normalizr";

const internalRate = new schema.Entity(`internal_rates`);
const arrayOfInternalRates = [internalRate];

export { internalRate, arrayOfInternalRates };
